import {
  SET_INSIGHTS_ACTIVE_CHANNELS,
  SET_INSIGHTS_ACTIVE_MEMBERS,
  SET_INSIGHTS_ACTIVITY_COUNT,
  SET_INSIGHTS_AVERAGE_MEMBERS,
  SET_INSIGHTS_AVERAGE_REPLIES,
  SET_INSIGHTS_ENGAGEMENT_METRICS,
  SET_INSIGHTS_MESSAGES_DATA,
  SET_INSIGHTS_TTFR,
  SET_INSIGHTS_WEEKLY_MESSAGES,
} from "../actionType";

const setInsightsActiveMembers = (data) => {
  return {
    type: SET_INSIGHTS_ACTIVE_MEMBERS,
    payload: data,
  };
};

const setInsightsAverageMembers = (data) => {
  return {
    type: SET_INSIGHTS_AVERAGE_MEMBERS,
    payload: data,
  };
};

const setInsightsActiveChannels = (data) => {
  return {
    type: SET_INSIGHTS_ACTIVE_CHANNELS,
    payload: data,
  };
};

const setInsightsActivityCount = (data) => {
  return {
    type: SET_INSIGHTS_ACTIVITY_COUNT,
    payload: data,
  };
};

const setInsightsAverageReplies = (data) => {
  return {
    type: SET_INSIGHTS_AVERAGE_REPLIES,
    payload: data,
  };
};

const setInsightsEngagementMetrics = (data) => {
  return {
    type: SET_INSIGHTS_ENGAGEMENT_METRICS,
    payload: data,
  };
};

const setInsightsMessagesData = (data) => {
  return {
    type: SET_INSIGHTS_MESSAGES_DATA,
    payload: data,
  };
};

const setInsightsTtfr = (data) => {
  return {
    type: SET_INSIGHTS_TTFR,
    payload: data,
  };
};

const setInsightsWeeklyMessages = (data) => {
  return {
    type: SET_INSIGHTS_WEEKLY_MESSAGES,
    payload: data,
  };
};

export {
  setInsightsActiveChannels,
  setInsightsActiveMembers,
  setInsightsActivityCount,
  setInsightsAverageMembers,
  setInsightsAverageReplies,
  setInsightsEngagementMetrics,
  setInsightsMessagesData,
  setInsightsTtfr,
  setInsightsWeeklyMessages,
};
